import React, { Component } from "react";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Fab,
  Divider,
} from "@material-ui/core";
import { GoSearch } from "react-icons/go";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Dropdown from "react-dropdown";
import DateTimePicker from "react-datetime-picker";
import TimePicker from "react-time-picker";
import Timer from "react-compound-timer";
import Modal from "react-awesome-modal";
import "./RelaxingTable.css";
import { GoogleComponent } from "react-google-location";
import { Map, Circle, GoogleApiWrapper } from "google-maps-react";
import firebase from "firebase/app";
import firestore from "firebase/firestore";
// import { firebaseConfig } from './Components/FirebaseConfig';
import { firebaseConfig } from "../FirebaseConfig";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  useHistory,
} from "react-router-dom";
import SimpleDateTime from "react-simple-timestamp-to-date";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

export class RelaxingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      RelaxingZones: [],
      AllZones: [],
      uid_relaxing: "",
      place_relaxing: null,
      zones_type: null,
      visible: false,
      startRelaxingTime: new Date(),
      endRelaxingTime: new Date(),
      editStartRelaxingTime: new Date(),
      editEndRelaxingTime: new Date(),
      edit_startTime: null,
      edit_endTime: null,
      startTime: null,
      endTime: null,
      edit_visible: false,
      edit_uid: null,
      search:'',
      days: [],
      1: "",
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
      0: "",
    };

    this._onSelectZone = this._onSelectZone.bind(this);
    this.onInputChange1 = this.onInputChange1.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange1(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange = event => {
    let newArray = [...this.state.days, event.target.value];
    if (this.state.days.includes(event.target.value)) {
      newArray = newArray.filter(day => day !== event.target.value);
    } 
    this.setState({
      days: newArray
    });
    // console.log(this.state.days)
  };

  reloadPage = async () => {
    window.location.reload(true);
  };

  componentDidMount() {
    this.getRelaxingCordinates();
    this.getAllCordinates();
  }

  _onSelectZone(option) {
    this.setState({ uid_relaxing: option.value });
    this.setState({ place_relaxing: option.label });
    // console.log("You selected ", this.state.uid_relaxing);
    console.log("You selected ", this.state.place_relaxing);
  }

  handleChange = (address) => {
    //send seaarch address
    this.setState({ address });
  };

  handleSelect = (address) => {
    //convert address to cordinates
    Geocode.setApiKey("AIzaSyB7Hwn_-eHX2Or_vobRHT0f4bejWcYPpx0");

    Geocode.setLanguage("en");
    Geocode.fromAddress(address).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        console.log(lat, lng);
        {
          this.setState({ zones_latitude: lat, zones_longitude: lng });
        }
      },
      (error) => {
        console.error(error);
      }
    );
    // console.log("ajkda: ",address);
    this.setState({ placeholder: address });
  };

  getRelaxingCordinates = async () => {
    //get violations data from firebase
    console.log("func chal raha hai k nhe ")
    

    if (this.state.search == null || this.state.search == "" || this.state.search == '') {
      let tempdata = [];

      const db = firebase.firestore();
      const snapshot = await db
      .collection("zones")
      .orderBy("publishTime", "asc")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          latitude: doc.data().latitude,
          zones_type: doc.data().zones_type,
          longitude: doc.data().longitude,
          place: doc.data().place,
          radius: doc.data().radius,
          key: doc.data().key,
          startTime: doc.data().startTime,
          endTime: doc.data().endTime
        };
        // tempdata.push(tempobj);
        if (tempobj.key == 1) {
          tempdata.push(tempobj);
        } else {
          console.log("NOt working");
        }

      });
      this.setState({ RelaxingZones: []});
      this.setState({ RelaxingZones: tempdata });
      
    } else {

      const db = firebase.firestore();
      let tempdata = [];

      const snapshot = await db
      .collection("zones")
      .orderBy("place", "desc")
      .where('place', '>=', this.state.search)
      .where('place', '<=', this.state.search+"\uf8ff")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          latitude: doc.data().latitude,
          zones_type: doc.data().zones_type,
          longitude: doc.data().longitude,
          place: doc.data().place,
          radius: doc.data().radius,
          key: doc.data().key,
          startTime: doc.data().startTime,
          endTime: doc.data().endTime
        };
        // tempdata.push(tempobj);
        if (tempobj.key == 1) {
          tempdata.push(tempobj);
        } else {
          console.log("NOt working");
        }
      });

      this.setState({ RelaxingZones: []});
      this.setState({ RelaxingZones: tempdata });
      
    }
      
      // .where('cnic', '>=', this.state.search)
      // .where('cnic', '<=', this.state.search+"\uf8ff")
      // .startAt([this.state.search])
      // .endAt([this.state.search+"\uf8ff"])
     

    // snapshot.forEach((doc) => {
    //   let tempobj = {
    //     uid: doc.id,
    //     first_name: doc.data().first_name,
    //     last_name: doc.data().last_name,
    //     cnic: doc.data().cnic,
    //     fine: doc.data().fine,
    //     violation_status: doc.data().violation_status,
    //     zone_id: doc.data().zone_id,
    //     exit_time: doc.data().exit_time,
    //     exit_zone: doc.data().exit_zone,
    //     email: doc.data().email,
    //   };
    //   tempdata.push(tempobj);
    // });
    // this.setState({ violations: tempdata });
  };

  onInputChange = async(event) => {

    // let string = event.target.value.toLower
    if (event.target.value.length < 1) {
      event.target.value = '';
      // this.getViolationData()     
      console.log("if ki value =", event.target.value)
      this.setState({ [event.target.name]: event.target.value});

      let tempdata = [];

      const db = firebase.firestore();
      const snapshot = await db
      .collection("zones")
      .orderBy("publishTime", "asc")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          latitude: doc.data().latitude,
          zones_type: doc.data().zones_type,
          longitude: doc.data().longitude,
          place: doc.data().place,
          radius: doc.data().radius,
          key: doc.data().key,
          startTime: doc.data().startTime,
          endTime: doc.data().endTime
        };
        // tempdata.push(tempobj);
        if (tempobj.key == 1) {
          tempdata.push(tempobj);
        } else {
          console.log("NOt working");
        }

      });
      this.setState({ RelaxingZones: []});
      this.setState({ RelaxingZones: tempdata });

    } else {
      console.log("else ki value =", event.target.value)
      this.setState({ [event.target.name]: event.target.value});
    }
    this.getRelaxingCordinates()      
}

  // getRelaxingCordinates = async () => {
  //   //get zones data from firebase
  //   let tempdata = [];
  //   const db = firebase.firestore();
  //   const snapshot = await db
  //     .collection("zones")
  //     .orderBy("publishTime", "desc")
  //     .get();
  //   snapshot.forEach((doc) => {
  //     let tempobj = {
  //       uid: doc.id,
  //       latitude: doc.data().latitude,
  //       zones_type: doc.data().zones_type,
  //       longitude: doc.data().longitude,
  //       place: doc.data().place,
  //       radius: doc.data().radius,
  //       key: doc.data().key,
  //       startTime: doc.data().startTime,
  //       endTime: doc.data().endTime,
  //     };

      // if (tempobj.key == 1) {
      //   tempdata.push(tempobj);
      // } else {
      //   console.log("NOt working");
      // }
  //     // tempdata.push(tempobj);
  //   });
  //   // console.log("End Time" + tempdata.endTime);
  //   // console.log("Start Time" + Date.parse(tempdata.startTime));

  //   this.setState({ RelaxingZones: tempdata });
  // };

  getAllCordinates = async () => {
    //get zones data from firebase
    let tempdata = [];
    const db = firebase.firestore();
    const snapshot = await db
      .collection("zones")
      .orderBy("publishTime", "desc")
      .get();
    snapshot.forEach((doc) => {
      let tempobj = {
        uid: doc.id,
        latitude: doc.data().latitude,
        zones_type: doc.data().zones_type,
        longitude: doc.data().longitude,
        place: doc.data().place,
        radius: doc.data().radius,
        key: doc.data().key,
        startTime: doc.data().startTime,
        endTime: doc.data().endTime,
        
      };
      if (tempobj.key == 0) {
        tempdata.push(tempobj);
      } else {
        console.log("NOt working");
      }
      // tempdata.push(tempobj);
    });
    this.setState({ AllZones: tempdata });
  };

  addRelaxingData = async () => {
    let startTime = this.state.startRelaxingTime;
    let endTime = this.state.endRelaxingTime;
    let startTimestamp = startTime;
    let endTimestamp = endTime;

    const db = firebase.firestore();
    const res = await db
      .collection("zones")
      .doc(this.state.uid_relaxing)
      .update({
        startTime: startTimestamp,
        endTime: endTimestamp,
        days: this.state.days

      });
    // await this.reloadPage();
    toast("Relaxing Hour Added Successfully", {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
      hideProgressBar: true,
    });
    this.setState({
      address: "",
    });
    this.getRelaxingCordinates();
  };

  // updateEditRelaxingData = async (update_id) => {
  //   let startTime = this.state.editStartRelaxingTime;
  //   let endTime = this.state.editEndRelaxingTime;
  //   let startTimestamp = startTime;
  //   let endTimestamp = endTime;

  //   // console.log("Musibat= " + update_id)
  //   const db = firebase.firestore();
  //   const res = await db.collection('zones').doc(update_id)
  //   .update({ 
  //     startTime: startTimestamp,
  //     endTime: endTimestamp,

  //   });
  //   // await this.reloadPage();
  //   toast('Zone Updated Successfull',
  //     {
  //       position: toast.POSITION.BOTTOM_CENTER,
  //       autoClose: 5000,
  //       hideProgressBar: true
  //     })
  //   alert('Zone Updates')
  //   this.getRelaxingCordinates();
  // }

  deleteRelaxingData = async (update_id) => {
    console.log("Musibat= " + update_id);
    const db = firebase.firestore();
    const res = await db.collection("zones").doc(update_id).update({ key: 0 });
    // await this.reloadPage();
    toast("Zone Updated Successfull", {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
      hideProgressBar: true,
    });
    this.getRelaxingCordinates();
  };

  // updateEditRelaxingData = async (update_id) => {
   
  //   console.log("Musibat= " + update_id)
  //   const db = firebase.firestore();
  //   const res = await db.collection('zones')
  //   .doc(update_id)
  //   .update({
  //      startTime: this.state.edit_startTime, 
  //      endTime: this.state.edit_endTime 
  //     });
  //   // await this.reloadPage();
  //   toast('Zone Updated Successfull',
  //     {
  //       position: toast.POSITION.BOTTOM_CENTER,
  //       autoClose: 5000,
  //       hideProgressBar: true
  //     })
  //   this.getRelaxingCordinates();

  // }

  onChangeStartRelaxingTime = (date) => {
    // TODO: FIREBASE

    console.log(date, "onChangeStartRelaxingTime");
    this.setState({
      startRelaxingTime: date,
    });
  };

  onChangeEndRelaxingTime = (date) => {
    // console.log(date,'onChangeEndRelaxingTime')
    // TODO: FIREBASE
    this.setState({
      endRelaxingTime: date,
    });
  };

  // onEditChangeStartRelaxingTime = (date) => {
  //   // TODO: FIREBASE

  //   console.log(date, "onChangeStartRelaxingTime");
  //   this.setState({
  //     editStartRelaxingTime: date,
  //   });
  // };

  // onEditChangeEndRelaxingTime = (date) => {
  //   // console.log(date,'onChangeEndRelaxingTime')
  //   // TODO: FIREBASE
  //   this.setState({
  //     editEndRelaxingTime: date,
  //   });
  // };

  openModal() {
    this.setState({
      visible: true,
    });
  }

  closeModal() {
    this.setState({
      visible: false,
    });
  }

  splitTime() {
    var st = this.state.startRelaxingTime;
    var et = this.state.endRelaxingTime;

    var st = st.split(":"); // split it at the colons
      var st = +st[0] * 60 * 60 + +st[1] * 60;
      var st = st * 1000;
      console.log("start:", st);

      var et = et.split(":"); // split it at the colons
      var et = +et[0] * 60 * 60 + +et[1] * 60;
      var et = et * 1000;
      console.log("end:", et);

      var diff = et - st
      console.log("diff:", diff);
       if (st >= et) //is st is greater that et toh gya andr
      {
        //10min == 600000
        alert("Error: Start Time Should Be Greater Than Ending Time");
        return;
      } 
      else if (diff < 180000) 
      {
        //10min == 600000
        alert("Error:Error: Relaxing Time Should Be Atleast 3 Min Long");
        return;
      } 
      else if (this.state.days == null || this.state.days == "") {
        alert("Error: Please Select Atleast One Day");
        return;
      }
      else{
        this.closeModal()
      this.addData(); 
      }  
  }

  AddRelaxingValidation = () => {
   

    // this.closeModal()
    if (this.state.place_relaxing == null) {
       alert("Error: Please Select Zone")
      return;
    }
    else if (typeof this.state.startRelaxingTime == "object") 
      {
        alert("Error: Please Choose Start Time");
        return;
      }
      else if (typeof this.state.endRelaxingTime == "object") 
      {
        alert("Error: Please Choose End Time");
        return;
      }   
      
     else {
        this.splitTime()
    }
  };

  dateConvertor(value) {
    if (value == null) {
      return <p>--</p>;
    } else {
      return (
        <p>{value}</p>
      );
    }
  }

  timeCounter(startTime, endTime) {
    var st = startTime;
    var et = endTime;

    if (startTime == null && endTime == null) 
    {
      return <p>--</p>;
    } 
    else {
      var a = st.split(":"); // split it at the colons
      var startSeconds = +a[0] * 60 * 60 + +a[1] * 60;
      var startSeconds = startSeconds * 1000;

      var b = et.split(":"); // split it at the colons
      var endSeconds = +b[0] * 60 * 60 + +b[1] * 60;
      var endSeconds = endSeconds * 1000;
     
      return (
        <Timer initialTime={endSeconds - startSeconds} direction="backward">
          {() => (
            <React.Fragment>
              {/* <Timer.Days /> Days / */}
              <Timer.Hours /> Hours /
              <Timer.Minutes /> Minutes /
              <Timer.Seconds /> Seconds
            </React.Fragment>
          )}
        </Timer>
      );
    }
  }

  onChangeKey(uid, startTime, endTime, days) {
    var today = new Date();
   
    var d = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // var d = new Date(dateString);
    var dayName = d[today.getDay()];

    let Current_day = dayName
    // let cd = Current_day.toLocaleString('de-AT',{weekday:'long'})
    console.log("current day = ",dayName)

    // let Current_hour = today.getHours()
    // let Current_mins = today.getMinutes()
console.log(days)
    let time = today.toLocaleString('de-AT', { hour: 'numeric', minute:'numeric', hour24: true })

    let num;
    if (days == undefined) {
      
    }
    else{
    num = days.length
    for (let index = 0; index < num; index++) {
      console.log("current day", Current_day)
      console.log("Index", days[index])
      // const element = array[index];
      if (days[index] == Current_day) {
        
        console.log("DANCE")
        if (time == startTime) {
          console.log("Time is equal to start Time")
          this.updateKeyToOne(uid, 1);
          // alert("key updated to 1")

        }else if(time == endTime){
          console.log("Time is not equal to start Time")
          this.updateKeyToZero(uid, 0);
          // alert("key updated to 0")
        }
        
      } else {
        console.log("NO DANCE")

      }
    }
    }
  }

  updateKeyToOne = async (uid, key) => {
    const db = firebase.firestore();
    const res = await db.collection("zones").doc(uid).update({
      key: key,
    });
  };

  updateKeyToZero = async (uid, key) => {
    const db = firebase.firestore();
    const res = await db.collection("zones").doc(uid).update({
      key: key,
      // startTime: null,
      // endTime: null,
    });
  };

 getValues(){
  {this.state.AllZones.map((value) =>
    this.onChangeKey(
      value.uid,
      value.startTime,
      value.endTime,
      // value.key,
      value.days,
      // console.log("DAYS what?", value.days)
    )
  )}
 }

  render() {
    return (
      <Paper className={"relaxingPaperCss"}>
         <div
          style={{
            height: "6.2vh",
            width: "100%",
            backgroundColor: "white",
            display:'flex',
            justifyContent:'flex-end',
            alignItems:'center',
            // marginBottom:'5%'
          }}
        >
          <div className={'relaxingSearchInputDiv'}>
          <input
            className={'relaxingSearchInput'}
            type={"text"}
            placeholder={"Search data..."}
            name={"search"}
            value={this.state.search}
            onChange={this.onInputChange}
          />
          <GoSearch style={{ height: 20, width: 20, color: '#21618C' }} />                            
          </div>
          
        </div>
        <TableContainer className={"relaxingTableContainerCss"}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className={"relaxingTableCell"}>
                  NAME
                </TableCell>
                <TableCell align="center" className={"relaxingTableCell"}>
                  START DATE/TIME
                </TableCell>
                <TableCell align="center" className={"relaxingTableCell"}>
                  END DATE/TIME
                </TableCell>
                <TableCell align="center" className={"relaxingTableCell"}>
                  COUNTDOWN
                </TableCell>
                <TableCell align="center" className={"relaxingTableCell"}>
                  ACTIONS
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {this.state.RelaxingZones.map((value) => (
                <TableRow>
                  <TableCell align="left">{value.place}</TableCell>
                  <TableCell align="center">
                    {this.dateConvertor(value.startTime)}
                  </TableCell>
                  <TableCell align="center">
                    {this.dateConvertor(value.endTime)}
                  </TableCell>
                  <TableCell align="center">
                    {this.timeCounter(value.startTime, value.endTime)}
                  </TableCell>
                  <TableCell align="inherit">
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                     
                      <DeleteIcon
                        className={'relaxingEditDeleteIcon'}                        
                        onClick={() => 
                          this.deleteRelaxingData(value.uid)
                        }
                      />

                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <div
            style={{
              position: "fixed",
              zIndex: "1",
              bottom: "5vh",
              right: "7vh",
            }}
          >
            <Fab
              size="large"
              aria-label="add"
              position="fixed"
              style={{ backgroundColor: "#6699ff", color: "white" }}
              onClick={() => this.openModal()}
            >
              <AddIcon />
            </Fab>
          </div>

          <Modal
            visible={this.state.visible}
            onClickAway={() => this.closeModal()}
            height="300px"
            width="70%"
          >
            <div className={"relaxingAddModelDiv"}>
              <p
                style={{
                  fontWeight: "bold",
                  color: "white",
                  textDecoration: "underline",
                  marginTop: "-1",
                  fontSize: "3.5vh",
                }}
              >
                ADD RELAXING ZONE
              </p>

              <div className={"relaxingAddDropdownBox"}>
                <div className={"relaxingAddDropDown"}>
                  <Dropdown
                    options={this.state.AllZones.map((value) => ({
                      value: value.uid,
                      label: value.place,
                    }))}
                    controlClassName="relaxingControlClassName"
                    className={"relaxingClassName"}
                    onChange={this._onSelectZone}
                    //  value={defaultOption}
                    menuClassName="relaxingMenuClassName"
                    placeholder="Select Zone..."
                    placeholderClassName="relaxingPlaceholderClassName"
                  />
                </div>
              </div>

              <div className={"relaxingAddModelTimeDiv"}>
                <div className={"relaxingAddModelFromTime"}>
                  <p
                    style={{
                      fontSize: "2.5vh",
                      marginTop:'2vh',
                      fontWeight: "bold",
                      marginRight: "2vh",
                      color: "white",
                    }}
                  >
                    From:
                  </p>
                  <div style={{ backgroundColor: "white" }}>
                    <TimePicker
                      onChange={this.onChangeStartRelaxingTime}
                      value={this.state.startRelaxingTime}
                    />
                  </div>
                </div>

                <Divider orientation="vertical" flexItem variant="middle" />

                <div className={"relaxingAddModelToTime"}>
                  <p
                    style={{
                      // backgroundColor:'red',
                      // height:'maxContent',
                      marginTop:'2vh',
                      fontSize: "2.5vh",
                      fontWeight: "bold",
                      marginRight: "2vh",
                      color: "white",
                    }}
                  >
                    To:
                  </p>
                  <div style={{ backgroundColor: "white" }}>
                    <TimePicker
                      onChange={this.onChangeEndRelaxingTime}
                      value={this.state.endRelaxingTime}
                    />
                  </div>
                </div>
              </div>

              <div className={"relaxingAddModelCheckbox"}>
              <p
                    style={{
                      fontSize: "2.5vh",
                      marginTop:'2.3vh',
                      fontWeight: "bold",
                      marginRight: "2vh",
                      color: "white",
                    }}
                  >
                    Select Days:
                  </p>
                <div>
                  <input
                    type={"checkbox"}
                    id="monday"
                    name={"1"}
                    value={"Monday"}
                    onChange={this.handleCheckboxChange}
                  />
                  <label for="monday">Monday</label>
                </div>
                <div>
                  <input
                    type={"checkbox"}
                    id="tursday"
                    name={"2"}
                    value={"Tuesday"}
                    onChange={this.handleCheckboxChange}
                  />
                  <label for="tuesday">Tuesday</label>
                </div>
                <div>
                  <input
                    type={"checkbox"}
                    id="wednesday"
                    name={"3"}
                    value={"Wednesday"}
                    onChange={this.handleCheckboxChange}
                  />
                  <label for="wednesday">Wednesday</label>
                </div>
                <div>
                  <input
                    type={"checkbox"}
                    id="thursday"
                    name={"4"}
                    value={"Thursday"}
                    onChange={this.handleCheckboxChange}
                  />
                  <label for="thursday">Thursday</label>
                </div>
                <div>
                  <input
                    type={"checkbox"}
                    id="friday"
                    name={"5"}
                    value={"Friday"}
                    onChange={this.handleCheckboxChange}
                  />
                  <label for="friday">Friday</label>
                </div>
                <div>
                  <input
                    type={"checkbox"}
                    id="saturday"
                    name={"6"}
                    value={"Saturday"}
                    onChange={this.handleCheckboxChange}
                  />
                  <label for="saturday">Saturday</label>
                </div>
                <div>
                  <input
                    type={"checkbox"}
                    id="sunday"
                    name={"0"}
                    value={"Sunday"}
                    onChange={this.handleCheckboxChange}
                  />
                  <label for="sunday">Sunday</label>
                </div>
              </div>

              <div className={"relaxingAddButtonsDiv"}>
                <button
                  className={"relaxingAddButton"}
                  onClick={() => this.AddRelaxingValidation() }
                >
                  ADD
                </button>
              </div>
            </div>
          </Modal>
        </TableContainer>
      </Paper>
    );
  }
}
export default RelaxingTable;
// export default GoogleApiWrapper({
//   apiKey: "AIzaSyA_d3pS7JqjFnGWc9hHkvT2MUQvAKo5Bio",
// })(ZonesTable);
